export default __webpack_public_path__ + "755f5af37d2aa4424abf3cde47f024a3.png";